import {
    apiRequest,
    indeksProfessionalitasDetail
} from "../../../../../services/adapters/kepegawaian/indeksProfessionalitas"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", indeksProfessionalitasDetail, {
            params: query
        }, true)
    }
}

export default DetailRepository